export const ItemLinkTypes = Object.freeze({
  INTERNAL: "internal",
  EXTERNAL: "external",
  PDF: "pdf"
});
